module.exports = __webpack_public_path__ + "img/Feature.146f85ac.png";